import React, { useEffect, useState } from 'react'
import { getSlider } from './actions';
import styles from './SliderView.module.scss';
import { Result } from 'antd';
import SliderBlockContent from './components/SliderBlockContent/SliderBlockContent';
import i18n from '../../lib/i18n';
import { useParams } from 'react-router-dom';


function SliderView() {
  let { id } = useParams();
  const [loaded, setLoaded] = useState(false)
  const [sliders, setSliders] = useState([])

  const getData = async () => {
    try {
      const data = await getSlider(id)
      setSliders(data?.sliders || [])
      setLoaded(true)
    } catch (error) {
      setLoaded(true)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  if(!loaded){
    return null;
  }


  if(sliders.length == 0){
    return <Result
      status="500"
      title={i18n('titleNotFoundSlider')}
      subTitle={i18n('msgNotFoundSlider')}
    />
  }
 
  return (<div className={styles['SliderViewBlock']}>
    <SliderBlockContent items={sliders} />
  </div>)
}

export default SliderView
